import React from "react";
import Video from "../assets/video/video.mp4";
import $ from 'jquery';
import {useTranslation} from "react-i18next";

const Loading = () => {
    const [ t ] = useTranslation(['home']);
    return (
        <div className="loading-screen" id="LoadingScreen">
            <video playsInline autoPlay loop autobuffer muted
                   src={Video}
                   className="big-image__video-background"></video>
            <div className="loading-screen__wrapper">
                <h4 className="loading-text">{t("loadingTheNewR")}</h4>
                <h1 className="section-title" id="LoadingNumber">0%</h1>
                <div className="loading__progress-container">
                    <div className="loading__progress" id="LoadingProgress"></div>
                </div>
            </div>
        </div>
    );
};

document.addEventListener("DOMContentLoaded", ()=>{
    //Disable scroll in this page
    $('html, body').css({
        overflow: 'hidden',
        height: '100%'
    });
    var count = 0;
    var counting = setInterval(function(){
        if(count < 101) {
            $('#LoadingNumber').text(count + '%');
            $('#LoadingProgress').css("width", (count + "%"))
            count++
        } else {
            clearInterval(counting)
            $('#LoadingScreen').addClass('loading-screen--hidden')
            //Restore scroll
            $('html, body').css({
                overflow: 'auto',
                height: 'auto'
            });
        }
    }, 35);
});

export default Loading;
